var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_vm._v("NotFoundComponent")])}
var staticRenderFns = []

export { render, staticRenderFns }